// 导航栏
export const NAV = [
  {
    title: "首页",
    url: "/",
    name: "Home",
    children: [],
    index: 0,
  },
  {
    title: "智能照明",
    url: "/smart_lighting",
    name: "smart_lighting",
    children: [
      "smart_lighting",
      "case_details",
      "smart_product",
      "product_detail",
    ],
    index: 1,
    subtab: 1,
    tab: [
      {
        title: "智能产品",
        // url: "/smart_lighting/#smart_title", // 锚点跳转
        url: "/smart_product", // 路径跳转
        icon1: require("@/assets/icon/hyfa1.png"), // 选中
        icon2: require("@/assets/icon/hyfa2.png"), // 未选中
        showState: false,
        anchor: "#smart_title",
        // name: "#smart_title",  // 锚点跳转 name
        name: ["smart_product", "product_detail"],
      },
      {
        title: "设计素材",
        url: "/smart_lighting/#dasgin_title",
        icon1: require("@/assets/icon/cpzs1.png"),
        icon2: require("@/assets/icon/cpzs2.png"),
        showState: false,
        anchor: "#dasgin_title",
        name: ["#dasgin_title"],
      },
      // {
      //   title: "家装案例",
      //   // url: "/smart_lighting/#dasgin_share",
      //   url: "https://www.kujiale.com/pub/site/design-zone/3D7RG7YHD3UG/designs?kpm=qkWL.8411f11a25ad0e71.1f62acb.1688463005503",
      //   icon1: require("@/assets/icon/alfx1.png"),
      //   icon2: require("@/assets/icon/alfx2.png"),
      //   showState: false,
      //   anchor: "#dasgin_share",
      //   name: ["#dasgin_share", "case_details"],
      // },
    ]
  },
  // {
  //   title: "西顿云设计",
  //   url: "/cloudDesign",
  //   name: "cloudDesign",
  //   children: [],
  //   index: 2,
  // },
  {
    title: "西顿舍见SMI",
    url: "https://cdn.thethinking.cn/#/pages/login/login",
    name: "cloudDesign",
    children: [],
    index: 2,
  },
  {
    title: "技术服务",
    url: "/training_services",
    name: "training_services",
    children: [
      "training_services",
      "technical_services",
      "coursed_details",
      "sign_up",
    ],
    index: 3,
    subtab: 2,
    tab: [
      {
        title: "设计下单",
        url: "/technical_services",
        name: ["technical_services"],
        icon1: require("@/assets/icon/sjxd1.png"),
        icon2: require("@/assets/icon/sjxd2.png"),
        showState: false,
      },
      {
        title: "技术培训",
        url: "/training_services",
        name: ["training_services", "coursed_details", "sign_up"],
        icon1: require("@/assets/icon/jspx1.png"),
        icon2: require("@/assets/icon/jspx2.png"),
        showState: false,
      },
    ]
  },
  {
    title: "关于我们",
    url: "/aboutIntroduce",
    name: "aboutIntroduce",
    children: ["aboutIntroduce", "aboutUs", "helpDetails"],
    index: 4,
    subtab: 3,
    tab: [
      {
        title: "关于我们",
        url: "/aboutIntroduce",
        name: ["aboutIntroduce"],
        icon1: require("@/assets/icon/gywm1.png"),
        icon2: require("@/assets/icon/gywm2.png"),
        showState: false,
      },
      {
        title: "帮助中心",
        url: "/aboutUs",
        name: ["aboutUs", "helpDetails"],
        icon1: require("@/assets/icon/bzzx1.png"),
        icon2: require("@/assets/icon/bzzx2.png"),
        showState: false,
      },
    ]
  },
]